//FIXME from iam-kit utils?!

export const tenantPaths = '/:tenantName'
export const ouPaths = '/:tenantName/OU/:ouId'
export const crossOuPaths = '/:tenantName/x-OU'

export const basePaths = [crossOuPaths, ouPaths, tenantPaths]
